import { formatarQtd, textoTotais } from "../../../lib/unidadeVenda";

export const reais = (v) => (v == null ? "—" : `R$ ${Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const reaisCurto = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1000) return `R$ ${(n / 1000).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} mil`;
  return reais(n);
};
export const pct = (v) => (v == null ? "—" : `${Number(v).toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%`);
// Quantidade vendida (30/09/2026): o servidor manda `unidades` (só o vendido por
// unidade), `kg` e `litros` à parte. "12 un · 3,500 kg"; `qtdTotal` ordena/compara.
export const qtdVendida = (r) => textoTotais({ un: r?.unidades, kg: r?.kg, L: r?.litros });
export const qtdTotal = (r) => (Number(r?.unidades) || 0) + (Number(r?.kg) || 0) + (Number(r?.litros) || 0);
export const qtdItem = (qtd, unidade) => (unidade ? formatarQtd(qtd, unidade) : `${formatarQtd(qtd, null)} un`);
export const num = (v) => (v == null ? "—" : Number(v).toLocaleString("pt-BR", { maximumFractionDigits: 1 }));
export const data = (iso) => (iso ? String(iso).slice(0, 10).split("-").reverse().join("/") : "—");
export const dataHora = (iso) => {
  if (!iso) return "—";
  const [d, h] = String(iso).split("T");
  return `${d.split("-").reverse().join("/")}${h ? ` ${h.slice(0, 5)}` : ""}`;
};
export const hojeMenos = (dias) => { const d = new Date(); d.setDate(d.getDate() - dias); return d.toLocaleDateString("sv-SE"); };
